import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { containerVariants, itemVariants } from '../../utils/animations';
import debtorApi, { Debtor } from '../../api/debtorApi';
import debtorDocumentApi, { DebtorDocument } from '../../api/debtorDocumentApi';

import DocumentSearchHeader from '../../components/debtor/document/DocumentSearchHeader';
import DocumentSearchFilters from '../../components/debtor/document/DocumentSearchFilters';
import DocumentSearchTable from '../../components/debtor/document/DocumentSearchTable';

export default function DocumentSearch() {
  const [documents, setDocuments] = useState<DebtorDocument[]>([]);
  const [debtors, setDebtors] = useState<Debtor[]>([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterType, setFilterType] = useState('all');
  const [filterStatus, setFilterStatus] = useState('all');

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const [debtorsData, docsData] = await Promise.all([
        debtorApi.getAll(),
        debtorDocumentApi.getAll(),
      ]);
      setDebtors(debtorsData || []);
      setDocuments(docsData || []);
    } catch (error) {
      // Error loading data
    } finally {
      setLoading(false);
    }
  };

  const getDebtorInfo = (debtorId: number) => {
    const debtor = debtors.find(d => d.id === debtorId);
    return {
      name: debtor?.full_name || '-',
      cif: debtor?.cif || '-',
    };
  };

  const filteredDocuments = documents.filter(doc => {
    const debtor = getDebtorInfo(doc.debtor_id);
    const matchSearch =
      debtor.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      debtor.cif.toLowerCase().includes(searchTerm.toLowerCase()) ||
      doc.document_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      doc.document_number?.toLowerCase().includes(searchTerm.toLowerCase());
    const matchType = filterType === 'all' || doc.document_type === filterType;
    const matchStatus = filterStatus === 'all' || doc.status === filterStatus;
    return matchSearch && matchType && matchStatus;
  });

  return (
    <motion.div
      className="space-y-6"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <motion.div variants={itemVariants}>
        <DocumentSearchHeader />
      </motion.div>

      <motion.div variants={itemVariants}>
        <DocumentSearchFilters
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          filterType={filterType}
          setFilterType={setFilterType}
          filterStatus={filterStatus}
          setFilterStatus={setFilterStatus}
        />
      </motion.div>

      <motion.div variants={itemVariants}>
        <DocumentSearchTable
          documents={filteredDocuments}
          loading={loading}
          getDebtorInfo={getDebtorInfo}
        />
      </motion.div>
    </motion.div>
  );
}
